import { render, staticRenderFns } from "./am-process-new.vue?vue&type=template&id=6f859aa2&scoped=true"
import script from "./am-process-new.vue?vue&type=script&lang=ts"
export * from "./am-process-new.vue?vue&type=script&lang=ts"
import style0 from "./am-process-new.vue?vue&type=style&index=0&id=6f859aa2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f859aa2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f859aa2')) {
      api.createRecord('6f859aa2', component.options)
    } else {
      api.reload('6f859aa2', component.options)
    }
    module.hot.accept("./am-process-new.vue?vue&type=template&id=6f859aa2&scoped=true", function () {
      api.rerender('6f859aa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/am-process/am-process-new.vue"
export default component.exports